import React from "react";
import { Card, CardBody } from "reactstrap";
import SvgIcon from "../../Common/Component/SvgIcon";
import { credoraIconClassName, resolveCredoraIconId } from "./CredoraIcon";

const trendClass = {
  success: "credora-table-metric__trend--success",
  warning: "credora-table-metric__trend--warning",
  danger: "credora-table-metric__trend--danger",
  info: "credora-table-metric__trend--info",
  neutral: "credora-table-metric__trend--neutral",
};

const resolveMetricIcon = (icon, iconClassName) => {
  const iconId = resolveCredoraIconId(icon) || icon;
  const resolvedClassName = credoraIconClassName(iconId, iconClassName);
  return { iconId, resolvedClassName };
};

const TablePageMetricCard = ({
  title,
  value,
  icon = "customers",
  iconTone = "primary",
  iconClassName,
  subtitle,
  trendLabel,
  trendTone = "success",
  progressPct = 0,
  progressTone = "primary",
}) => {
  const { iconId, resolvedClassName } = resolveMetricIcon(icon, iconClassName);

  return (
    <Card className={`credora-table-metric credora-table-metric--${iconTone}`}>
      <CardBody>
        <div className="credora-table-metric__head">
          <div className={`credora-table-metric__icon credora-table-metric__icon--${iconTone}`}>
            <SvgIcon className={resolvedClassName} iconId={iconId} />
          </div>
          {trendLabel && (
            <span className={`credora-table-metric__trend ${trendClass[trendTone] || trendClass.neutral}`}>
              {trendLabel}
            </span>
          )}
        </div>
        <h3 className="credora-table-metric__value">{value}</h3>
        <p className="credora-table-metric__label">{title}</p>
        {subtitle && <p className="credora-table-metric__subtitle">{subtitle}</p>}
        <div className="credora-table-metric__progress">
          <div className="credora-table-metric__progress-track">
            <div
              className={`credora-table-metric__progress-bar credora-table-metric__progress-bar--${progressTone}`}
              style={{ width: `${Math.min(100, Math.max(0, progressPct))}%` }}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default TablePageMetricCard;
